import { make } from 'vuex-pathify'

import categories from "@/data/parts/categories.js";
import categoriesLegend from "@/data/parts/categoriesLegend.js";
// import parts from "@/data/parts/parts.js";
import * as firebase from '@/firebase.js'
import * as Dimensions from '@/lib/dimensions';
import * as Units from '@/lib/units';

const state = {
  categoriesLegend,
  parts: [],
  partsLoading: false,
  highlightedParts: false,
}

const getters = {
  ...make.getters([...Object.keys(state)]),
  partsUnfiltered: (state, getters, rootState, rootGetters) => {
    // TODO use series
    let parts = state.parts.filter(part => (
      part && 
      Object.keys(part).length != 0 && 
      !part.disabled 
    ));
    if(!rootState.search_filter){
      parts = parts.filter(part => (
        (rootState.useMetric && Dimensions.isMetric(part)) || 
        (!rootState.useMetric && Dimensions.isImperial(part))
      ))
    }
    if(rootGetters.seriesFilter && !rootState.search_filter){
      parts = parts.filter(part => {
        if(part.details && part.details["Series"]){
          return part.details["Series"].toLowerCase().includes(rootGetters.seriesFilter) || (rootState.useMetric && Dimensions.isGenericMetric(part)) || (!rootState.useMetric && Dimensions.isGenericImperial(part));
        }
        return true;
      })
    }else{
      parts = parts.filter(part => {
        return part.details && part.details["Series"]
      })
    }
    return parts
  },
  parts: (state, getters, rootState) => {
    let parts = getters.partsUnfiltered;
    if(rootState.search_filter && rootState.search_filter.trim().length > 1){
      const search = rootState.search_filter.toLowerCase().replace("q-", "");
      parts = parts.filter(part => {
        const id = part.id ? part.id.toLowerCase() : "";
        const name = part.name ? part.name.toLowerCase() : "";
        const description = part.description ? part.description.toLowerCase() : "";
        return id.includes(search) || name.includes(search) || description.includes(search)
      })
    }
    if(rootState.rail_height_filter){
      parts = parts.filter(part => rootState.rail_height_filter == part.details.width)
    }
    if(rootState.profile_filter){
      parts = parts.filter(part => {
        if(part.profile){
          return part.profile.includes(rootState.profile_filter)
        }else{
          return true;
        }
      })
    }
    if(rootState.construction_filter){
      parts = parts.filter(part => {
        if(part.id){
          if(rootState.construction_filter == "Solid"){
            return !part.id.toLowerCase().includes("l")
          }else if(rootState.construction_filter == "Light-Weight"){
            return part.id.toLowerCase().includes("l") && !part.id.toLowerCase().includes("ul")
          }else if(rootState.construction_filter == "Ultra-Light-Weight"){
            return part.id.toLowerCase().includes("ul")
          }
        }
        return true;
      })
    }
    return parts
  },
  partsByCategory: (state, getters, rootState, rootGetters) => (category) => {
    const parts = getters.parts.filter((part, index) => (
      part.categories ? part.categories.includes(category?.id) : false
    )).filter(part => !part.hidden)
    if(category.defaultParts && Object.keys(category.defaultParts).length > 0){
      let defaults = [];
      if(rootGetters.seriesFilter){
        if(category.defaultParts[rootGetters.seriesFilter]){
          defaults = category.defaultParts[rootGetters.seriesFilter]
        }else if(rootState.useMetric && category.defaultParts["METRIC"]){
          defaults = category.defaultParts["METRIC"]
        }else if(!rootState.useMetric && category.defaultParts["FRACTIONAL"]){
          defaults = category.defaultParts["FRACTIONAL"]
        }else if(category.defaultParts["ALL"]){
          defaults = category.defaultParts["ALL"]
        }
      }
      else{
        if(rootState.useMetric){
          for(let i = 0; i < 10; i++){
            category.defaultParts["20"] && category.defaultParts["20"][i] && defaults.push(category.defaultParts["20"][i])
            category.defaultParts["25"] && category.defaultParts["25"][i] && defaults.push(category.defaultParts["25"][i])
            category.defaultParts["30"] && category.defaultParts["30"][i] && defaults.push(category.defaultParts["30"][i])
            category.defaultParts["40"] && category.defaultParts["40"][i] && defaults.push(category.defaultParts["40"][i])
            category.defaultParts["45"] && category.defaultParts["45"][i] && defaults.push(category.defaultParts["45"][i])
            category.defaultParts["METRIC"] && category.defaultParts["METRIC"][i] && defaults.push(category.defaultParts["METRIC"][i])
            category.defaultParts["ALL"] && category.defaultParts["ALL"][i] && defaults.push(category.defaultParts["ALL"][i])
          }
        }else{
          for(let i = 0; i < 10; i++){
            category.defaultParts["10"] && category.defaultParts["10"][i] && defaults.push(category.defaultParts["10"][i])
            category.defaultParts["15"] && category.defaultParts["15"][i] && defaults.push(category.defaultParts["15"][i])
            category.defaultParts["Fractional"] && category.defaultParts["Fractional"][i] && defaults.push(category.defaultParts["Fractional"][i])
            category.defaultParts["ALL"] && category.defaultParts["ALL"][i] && defaults.push(category.defaultParts["ALL"][i])
          }
        }
      }
      return [
        ...defaults.reduce((acc, id) => {
            const p = parts.find(part => part.id == id)
            return p ? [...acc, p] : acc;
          }, []),
        ...parts.filter(part => !defaults.includes(part.id))
      ]
    }else{
      return parts;
    }
  },
  partsByCategoryUnfiltered: (state, getters, rootState) => (category) => {
    return getters.partsUnfiltered.filter((part, index) => (
      part.categories ? part.categories.includes(category?.id) : false
    )).filter(part => !part.hidden)
  },
  getPartsCount: (state, getters) => (category) => {
    const filtered_count = getters.partsByCategory(category).length
    const unfiltered_count = getters.partsByCategoryUnfiltered(category).length
    if(unfiltered_count == 0){
      return "(0)"
    }else if(unfiltered_count == filtered_count){
      return "("+filtered_count+")";
    }else{
      return "("+filtered_count+"/"+unfiltered_count+")"
    }
  },
  partById: (state) => (id) => {
    return state.parts.find(part => part.id == id)
  },
  categoryById: (state) => (id) => {
    return categories[id]
  },
  getVendorForPart: (state, getters, rootState, rootGetters) => (part) => {
    if(part && part.vendors){
      if(Object.keys(part.vendors).length > 0){
        return part.vendors[Object.keys(part.vendors)[0]];
      }
    }
    return null
  },
  getPartCountFromLedger: (state, getters) => (ledger) => {
    let count = 0;
    if(ledger){
      ledger.forEach((ledgerPart) =>{
        count += ledgerPart.quantity
      })
    }
    return count
    // return Object.keys(partLedger).reduce((acc, key) => acc + partLedger[key], 0);
  },
}

const mutations = {
  ...make.mutations([...Object.keys(state)]),
}

const actions = {
  loadParts: ({commit, rootState}) => {
    return new Promise((resolve, reject)=>{
      commit("partsLoading", true);
      firebase.db.collection("parts").where("name", "!=", false).get().then((querySnapshot) => {
        commit("partsLoading", false);
        if(!querySnapshot.empty){
          const parts = [];
          querySnapshot.forEach((part) => {
            parts.push(part.data())
          });
          // console.log(parts);
          commit("parts", parts);
          resolve();
        }else{
          commit("parts", []);
          resolve();
        }
      }).catch(e => {
        commit("partsLoading", false);
        reject(e);
      });
    })
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}